<div class="structure-wrapper">
    <div>Generates an image maintaining the structure of an input image</div>
    <expandable-prompt
        (promptChange)="onPromptChange($event)"
        [disabled]="isRequestingStructure()"
        [canExpand]="false"
        [type]="ExpandablePromptInputType.StructurePrompt" />

    <expandable-prompt
        [disabled]="isRequestingStructure()"
        (promptChange)="onNegativePromptChange($event)" />

    <div class="slider-text">
        <div>AI Control Strength:</div>
        <ui-icon
            class="help-icon"
            icon="help"
            uiTooltipPosition="bottom"
            uiTooltip="How much influence, or control, the image has on the generation" />
    </div>
    <div class="slider-control">
        <ui-range
            [min]="0"
            [max]="10"
            [value]="controlStrength || 0"
            (valueChange)="adjustControlStrength($event)">
        </ui-range>

        <ui-number-input
            [value]="controlStrength"
            (valueChange)="adjustControlStrength($event)" />
    </div>

    <div class="section generate-actions">
        <ui-button
            id="interaction-generate-from-structure"
            type="primary"
            text="Generate from structure"
            [disabled]="actionsDisabled()"
            [loading]="isRequestingStructure()"
            (click)="structure()" />
    </div>
</div>
